import { KeyboardKeys } from '~shared/constants';

export namespace KeyboardUtil {

  export function isEnter(event: KeyboardEvent): boolean {
    return [
      KeyboardKeys.Enter,
      KeyboardKeys.NumpadEnter,
    ].some(k => k === event.code || k === event.key);
  }

  export function isArrowUp(event: KeyboardEvent): boolean {
    return event.code === KeyboardKeys.ArrowUp ||
      event.key === KeyboardKeys.ArrowUp;
  }

  export function isArrowDown(event: KeyboardEvent): boolean {
    return event.code === KeyboardKeys.ArrowDown ||
      event.key === KeyboardKeys.ArrowDown;
  }

  export function isArrowRight(event: KeyboardEvent): boolean {
    return event.code === KeyboardKeys.ArrowRight ||
      event.key === KeyboardKeys.ArrowRight;
  }

  export function isArrowLeft(event: KeyboardEvent): boolean {
    return event.code === KeyboardKeys.ArrowLeft ||
      event.key === KeyboardKeys.ArrowLeft;
  }

  export function isArrow(event: KeyboardEvent): boolean {
    return isArrowUp(event)
      || isArrowDown(event)
      || isArrowRight(event)
      || isArrowLeft(event);
  }

}
